module.exports = __webpack_public_path__ + "static/media/Wingull_gaussian2.bf91de5d.png";